import { Link } from 'react-router-dom';
import type { MediaTitle } from '@/types';

interface TitleCardProps {
  item: MediaTitle;
}

export default function TitleCard({ item }: TitleCardProps) {
  const isTv = item.type === 'tv';
  const meta = isTv
    ? `${item.year} · ${item.region} · ${item.seasons}季`
    : `${item.year} · ${item.region} · ${item.duration}`;

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-primary-950">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} - 星辰影院`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/10 to-transparent opacity-80" />

        {/* rating badge */}
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[11px]" />
          {item.rating.toFixed(1)}
        </span>

        {/* type tag */}
        <span className="absolute right-2.5 top-2.5 rounded-md bg-black/55 px-2 py-1 text-[11px] font-medium text-background-100 backdrop-blur-sm">
          {isTv ? '电视剧' : '电影'}
        </span>

        {/* hover summary */}
        <div className="absolute inset-x-0 bottom-0 translate-y-3 p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="line-clamp-3 text-xs leading-relaxed text-background-200">{item.summary}</p>
        </div>
      </div>

      <div className="px-3 py-3">
        <h3 className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">{meta}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}